export default __webpack_public_path__ + "static/media/blood-pressure.56156cb3.png";